import type { ImagePopup, Popup } from '../models/popup.types'

export const isImagePopup = (popup: Popup): popup is ImagePopup => {
    return 'image' in popup
}
